import { ClaimV2CornSchema } from '@eigtech/claims-v2-types';
import { JobCornSchema } from '@eigtech/restoration-types';
import { z } from 'zod';
import { InspectionCornSchema } from '../base.js';
import { VideoWithSignedUrlSchema } from '../entities/video.js';
import { LabelFilterSchema } from '../util.js';
export const GetInspectionVideosApiSchema = {
    params: z.object({
        entityId: z.union([ClaimV2CornSchema, JobCornSchema]),
        inspectionId: InspectionCornSchema,
    }),
    query: LabelFilterSchema,
    response: z.object({
        videos: VideoWithSignedUrlSchema.array(),
    }),
};
export const GetInspectionVideosRequestSchema = GetInspectionVideosApiSchema.params.merge(GetInspectionVideosApiSchema.query);
